export const updateMata = (mata, namespace) => ({
    type: namespace + '_UPDATE_MATA',
    mata: mata,
    id: namespace
});

const initialState = {id: '', mata: []};
let mata = (namespace) => (state = initialState, action = {}) => {
    if (action.type === namespace + '_UPDATE_MATA') {
        return Object.assign({}, {id: action.id, mata: action.mata})
    }
    return state;
};

export default mata;


// WEBPACK FOOTER //
// ./src/state/mataToShare.js